import React from "react";
import Form from "react-bootstrap/Form";

function InputField({
  field,
  label,
  value,
  onChange,
  error,
  type = "text",
  as = "Form.Group",
  pattern = "^[A-Za-z0-9 ]+$",
  controlId = "applicant",
  options = [], // Add this for select options
  disabled = false,
  min = ""
}) {
  const handleInputChange = (e) => {
    let newValue = e.target.value;

    if (pattern === "^[0-9]*$") {
      newValue = newValue.replace(/\D/g, "");
    }
    // Don't strip dashes for phone number pattern
    // The formatting is handled in the parent component

    onChange(field, newValue);
  };

  return (
    <Form.Group as={as} controlId={`${controlId}${field}`}>
      <Form.Label>{label}<span className="text-danger">*</span></Form.Label>
      {type === "select" ? (
        <Form.Select
          value={value}
          onChange={(e) => onChange(field, e.target.value)}
          isInvalid={!!error}
        >
          <option value="">Select {label}</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Form.Select>
      ) : (
        <Form.Control
          type={type}
          value={value}
          onChange={handleInputChange}
          isInvalid={!!error}
          pattern={type === "text" ? pattern : undefined}
          disabled={disabled}
          min={min}
        />
      )}
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </Form.Group>
  );
}

export default InputField;
